/*=========================================================================================
  File Name: moduleTraineeAttendanceActions.js
  Description: TraineeAttendance Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default { 
  SaveTraineeAttendance(context, item) {
    debugger
    return new Promise((resolve, reject) => {
      axios.put("api/TraineeAttendance/UpdateTraineeAttendance", item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  SaveInstructorAttendance(context, item) {
    debugger
    return new Promise((resolve, reject) => {
      axios.put("api/InstructorAttendance/UpdateInstructorAttendance", item)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  
  GetTraineeAttendanceBySession({ commit },data) {
    return new Promise((resolve, reject) => {
      axios.get("api/TraineeAttendance/GetTraineeAttendanceBySession?SessionID="+data.sessionID+"&CourseClassID="+data.courseClassID)
        .then((response) => {
          commit('SET_TraineeAttendance', response.data)
          
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  GetInstructorAttendanceBySession({ commit },data) {
    return new Promise((resolve, reject) => {
      axios.get("api/TraineeAttendance/GetInstructorAttendanceBySession?SessionID="+data.sessionID+"&CourseClassID="+data.courseClassID)
        .then((response) => {
          commit('SET_InstructorAttendance', response.data)
          
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
 
  GetTraineeAttendanceByTraineeID({ commit },ID) {
    return new Promise((resolve, reject) => {
      
      axios.get("api/TraineeAttendance/GetTraineeAttendanceByTraineeID?traineeID="+ID)
        .then((response) => {
          commit('SET_TraineeAttendance', response.data)
          
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
